import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css'
import Home from './pages/Home'
import Login from './pages/Login'
import User from './pages/User';
import ActionPlan from './pages/ActionPlan';
import Budget from './pages/Budget';
import Reporting from './pages/Reporting';
import Settlement from './pages/Settlement';
import DDO from './pages/DDO';
import DDOPending from './pages/DDOPending';
import DEE from './pages/DEE';
import DEEPending from './pages/DEEPending';
import FundAllocation from './pages/FundAllocation';
import NotesheetDownload from './pages/NotesheetDownload';
import Accountant from './pages/Accountant';
import AccSettle from './pages/AccSettle';
import GeneralNotesheet from './pages/GeneralNotesheet';
import DDONotesheet from './pages/DDONotesheet';
// import Notesheet from './pages/Notesheet';
import AccountantPending from './pages/AccountantPending';
import OtherStaff from './pages/OtherStaff';
import NotesheetDownload2 from './pages/NotesheetDownload2';
import NotesheetDownload3 from './pages/NotesheetDownload3';
import SSH from './pages/SSH';
import SSHPending from './pages/SSHPending';
import ReportDisplay from './pages/ReportDisplay';
import LeaveAllocation from './pages/LeaveAllocation';
import LeaveApplication from './pages/LeaveApplication';
import Welcome from './pages/Welcome';

const App = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/user" element={<User />} />
          <Route path="/ap" element={<ActionPlan />} />
          <Route path="/accpending" element={<DDONotesheet />} />
          <Route path="/budget" element={<Budget />} />
          <Route path="/reporting" element={<Reporting />} />
          <Route path="/reportdisplay" element={<ReportDisplay />} />
          <Route path="/settlement" element={<Settlement />} />
          <Route path="/ddo" element={<DDO />} />
          <Route path="/ssh" element={<SSH />} />
          <Route path="/sshpending" element={<SSHPending />} />
          <Route path="/generalnotesheet" element={<GeneralNotesheet />} />
          <Route path="/accountant" element={<Accountant />} />
          <Route path="/accsettle" element={<AccSettle />} />
          <Route path="/ddopending" element={<DDOPending />} />
          <Route path="/dee" element={<DEE />} />
          <Route path="/deepending" element={<DEEPending />} />
          <Route path="/fundallocation" element={<FundAllocation />} />
          {/* <Route path="/notesheet" element={<Notesheet />} /> */}
          <Route path="/notesheetdownload" element={<NotesheetDownload />} />
          <Route path="/notesheetdownload2" element={<NotesheetDownload2 />} />
          <Route path="/notesheetdownload3" element={<NotesheetDownload3 />} />
          <Route path="/accountantpending" element={<AccountantPending />} />
          <Route path="/otherstaff" element={<OtherStaff />} />
          <Route path="/leaveallocation" element={<LeaveAllocation />} />
          <Route path="/leaveapplication" element={<LeaveApplication />} />
          <Route path="/welcome" element={<Welcome />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
